export default {
  SING_IN: "Login",
  SING_UP: "Sign up",
  SING_UP_DATE: "Sign up Date",
  SING_IN_HELP_TEXT: "Enter to continue and explore within your grasp.",
  MOBILE_NUMBER: "Mobile number",
  SECONDARY_MOBILE: "Secondary mobile number",
  PASSWORD: "Password",
  CONFIRM_PASSWORD: "Confirm Password",
  ENTER_YOUR_PASSWORD: "Enter your password",
  LOGIN_TO_CONTINUE: "Login to Continue",
  FORGOT_PASSWORD: "Forgot Password",
  CHANGE_PASSWORD: "Change Password",
  OTP: "OTP",
  ENTER_OTP: "Enter OTP",
  CONTINUE: "Continue",
  RESEND_OTP: "Resend OTP",
  LOGOUT: "Logout",
  BACK: "Back",
  VERIFY_ACCOUNT: "Verify",

  ADD_STUDENTS: "Add Students",
  STUDENT_ID: "Student ID",
  STUDENT_BASIC_DETAILS: "Basic Details",
  STUDENT_ADDRESS_DETAILS: "Address Details",
  STUDENT_ACADEMIC_DETAILS: "Academic Details",
  PROFESSIONAL_DETAILS: "Professional Details",
  OTHER_DETAILS: "Other Details",
  CONTACT_DETAILS: "Contact Details",
  UPLOAD_DOCUMENTS: "Upload Documents",
  PERSONAL_VEHICLE: "Do you have Personal Vehicle?",
  PERSONAL_COMPUTER: "Do you have Personal Computer?",
  ACHIEVEMENTS: "Achievements",

  NAME: "Name",
  ADD_MORE_STUDENT: "Add more Student",
  STUDENT: "Student",
  STUDENT_NAME: "Student Name",
  FATHER_NAME: "Father Name",
  MOTHER_NAME: "Mother Name",
  MOTHER_CONTACT_NUMBER: "Mother Contact number",
  PARENT_MOBILE_NUMBER: "Parent Contact number",
  WA_MOBILE_NUMBER: "Whatsapp number",
  GUARDIAN_CONTACT_NUMBER: "Guardian Contact number",
  ALTERNATE_MOBILE_NUMBER: "Alternate Mobile Number",
  GENDER: "Gender",
  DATE_OF_BIRTH: "Date of Birth",
  EMAIL: "Email",
  CITY: "City",
  LANDMARK: "Landmark",
  STATE: "State",
  ADDRESS: "Address",
  PIN_CODE: "Pin code",
  INSTITUTE_NAME: "Institute Name",
  CLASS: "Class",
  SUITABLE_TIME_SLOT: "Suitable Time slot",
  SUITABLE_DAYS: "Suitable Days",
  MODE_OF_CLASS: "Mode of class",
  TEACHING_PREFERENCE: "Teaching Preference",
  MORNING: "Morning",
  AFTER_NOON: "Afternoon",
  EVENING: "Evening",
  SUBJECTS: "Subjects",
  SPECIAL_CONCERN: "Special Concern",
  TOPICS_COVERED: "Topics Covered",
  TEACHER_PAY_RATE: "Pay Rate",
  TRAVEL_EXPENSE_RATE: "Travel Expense Rate",
  SPECIALITY: "Speciality",
  ABOUT_YOURSELF: "About yourself",
  EXPERIENCE: "Teaching Experience",

  EDUCATION_BOARD: "Board",
  SCHOOL_NAME: "School name",
  COLLAGE_NAME: "College name",
  HOBBIES: "Hobbies",
  TYPE: "Type",
  DEMO_DETAILS: "Demo Details",
  INTERESTED_TUTOR: "Interested Tutor",
  TUTOR_SUGGESTION: "Tutor Suggestion",
  NO_DATA_AVAILABLE: "No Data Available",
  APPROVE: "Approve",

  /* subscription plan */
  CREATE_SUBSCRIPTION_PLAN: "Create New Plan",
  ADD_SUBSCRIPTION_PLAN: "Add Subscription Plan",
  PLAN_TYPE: "Plan Type",
  PLAN_NAME: "Plan Name",
  PRICE: "Price",
  DISCOUNT: "Discount",
  TOTAL: "Total",
  HOURS: "Hours",
  EXPIRY_DATE: "Expiry date",
  REMAINING_TEACHING_HOURS: "Remaining teaching hours",
  GRADE: "Grade",
  VALIDITY: "Validity",
  GST_PERCENT: "GST Percent",
  DESCRIPTION: "Description",
  SUBMIT: "Submit",
  SAVE: "SAVE",
  CANCEL: "Cancel",
  CLOSE: "Close",
  ADD_ON_VALIDITY: "Same as current subscription plan",
  NO_OF_STUDENT_ALLOWED: "Students allowed",
  NO_OF_SUBJECTS_ALLOWED: "Subjects allowed",
  CLASSES_PER_WEEK: "Classes per Week",
  INVOICE_TYPE: "Invoice type",
  BATCH_ID: "Batch Id",
  SESSIONS: "Sessions",
  ASSOCIATE_ID: "Associate ID",
  DOWNLOAD_INVOICE: "Download Invoice",

  /* student registration form  string */
  ALREADY_HAVE_AN_ACCOUNT: "Already have an account?",
  NOT_HAVE_AN_ACCOUNT: "Don't have an account?",
  STUDENT_REGISTRATION_FORM: "Student Registration Form",
  REG_STUDENT_BASIC_DETAILS: "Enter basic details to get started",
  REG_ENTER_OTP: "Enter OTP",
  REG_ENTER_OTP_HELP_TEXT: "Please enter OTP send on your Mobile",

  TUTOR_REGISTRATION_FORM: "Tutor Registration Form",

  /* tutor basic details */
  TUTOR: "Tutor",
  TUTOR_ID: "Tutor ID",
  TUTOR_DETAILS: "Tutor Details",
  TUTOR_NAME: "Tutor Name",
  TUTOR_PREFERENCE: "Tutor Preference",
  EDIT_PROFILE: "Edit Profile",
  PROFILE_STATUS: "Profile Status",
  EDIT: "Edit",
  TEN_TH_SCORE: "10th Score",
  TWELVE_TH_SCORE: "12th Score",
  COURSE_NAME: "Course Name",
  SCORE: "Score",
  STREAM: "Stream",
  STATUS: "Status",
  BASIC_DETAILS: "Basic Details",
  ONLINE: "Online",
  OFFLINE: "Offline",
  PREFERRED_BOARD: "Select Board",
  CONTACT_PERSON: "Contact Person",

  DATE: "Date",
  TIME: "Time",
  COMMENTS: "Comments",
  HOMEWORK_DESCRIPTION: "Homework description",
  FILTER: "Filter",
  FILTER_USING: "Filter using",
  FROM_DATE: "From date",
  TO_DATE: "To date",
  FILTER_SELECTED: "Filters Selected",
  CLEAR_ALL: "Clear All",
  APPLY: "Apply",
  SEARCH: "Search",
  ADD: "Add",
  BUSINESS_DEVELOPER: "Business Developer",
  ADD_BUSINESS_DEVELOPER: " Add Business Developer",
  ADD_EXECUTIVE: " Add Executive",
  CREATE_BATCH: "Create New Batch",
  START_SESSION: "Start New Class",
  SUBSCRIPTION_PLAN: "Subscription Plan",
  SUBSCRIPTION_HISTORY: "Subscription History",
  BUY_NOW: "Buy Now",
  MEETING_URL: "Meeting URL",
  PAYMENT_TYPE: "Payment Type",
  NUMBER_OF_INSTALLMENT: "Number of Installment",
  NUMBER_OF_STUDENTS: "Number of Students",
  BATCH: "Batch",
  TENURE: "Tenure",
  DURATION: "Duration",
  SUBJECT: "Subject",
  MARKS: "Marks",
  CATEGORY: "Category",
  RAISE_TICKET: "Raise Ticket",
  COLLECT_REGISTRATION_PAYMENT: "Collect Registration Fee",
  MODE: "Mode",

  ACCOUNT_HOLDER_NAME: "Account Holder Name",
  ACCOUNT_NUMBER: "Account Number",
  IFSC_CODE: "IFSC Code",
  UPI_ID: "UPI ID",
  BANK_NAME: "Bank Name",
  BRANCH: "Branch",
  SECURITY_DEPOSIT: "Security Deposit",
  SETTINGS: "Settings",
  REGISTRATION_FEE_REQUIRE: "Registration Fee Require",
  HAVE_A_PROMO_CODE: "Have a Promocode?",

  TICKET_ID: "Ticket id",
  RAISED_BY: "Raised By",
  RAISED_ON: "Raised on",
  CLOSED_BY: "Closed By",
  CLOSED_ON: "Closed On ",
  CLOSED_TICKET: "Close Ticket",

  BDA: "Bussiness Developer",
  IS_ONLINE: "Is Online",
  REMARK: "Remark",
  MDDE: "Mode",
  REJECT: "Reject",
  SELECT: "Select",
  RESCHEDULE: "Re Schedule",

  INTERVIEWER: "Interviewer",
  INTERVIEWER_NAME: "Interviewer name",
  INTERVIEWER_MOBILE: "Interviewer mobile",

  BANK_ACCOUNT_DETAILS: "Bank Account Details",
  WITHDRAW: "Withdraw",
  DEDUCTION: "Deduction",
  AMOUNT: "Amount",
  BALANCE: "Balance",
  LOAD_MORE: "Load more",
  DESIGNATION: "Designation",

  BDA_ABBREVIATION: {
    "Admission Counsellor": "AdC",
    "Academic Counsellor": "AcC",
    "Admission Coordinator": "ACo",
    "Recruitment Manager": "RM",
  },

  RAISE_WITHDRAW_REQUEST: "Raise Withdraw Request",

  PERSONAL_INTERVIEW: "Personal Interview",
  ACADEMIC_KNOWLEDGE: "Academic Knowledge",
  TEACHING_SKILLS: "Teaching Skills",
  DEMO_SESSION: "Demo Session",
  OFFICE_REMARKS: "Office Remarks",

  READING: "Reading",
  WRITING: "Writing",
  LISTENING: "Listening",
  COMMUNICATION: "Communication",
  PRESENCE_OF_MIND: "Presence of mind",
  SUBJECTIVE_KNOWLEDGE: "Subjective knowledge",
  GOOD_HABITS: "Good habits",
  BAD_HABITS: "Bad habits",

  RATING_DESCRIPTION: {
    1: "Poor",
    2: "Below Average",
    3: "Average",
    4: "Good",
    5: "Excellent",
  },

  /* search place holders */
  SUBSCRIPTION_PLAN_SEARCH:
    "Search by subscription plan name,Student Name, Mobile, Email",
  STUDENT_SUBSCRIPTION_SEARCH: "Search by subscription plan name",
  STUDENT_SEARCH: "Search by Student ID, Name, Mobile, Email",
  TUTOR_SEARCH: "Search by Tutor ID, Name, Mobile, Email",
  DEMO_SEARCH: "Search by Student ID, Name, Mobile, Email",
  LEAD_SEARCH: "Search by Lead ID, Name, Mobile number",
  BDA_SEARCH: "Search by Associate ID, Name, Mobile, Email",
  UNIT_TEST_SEARCH: "Search by Test number, student Name, Email",
  TICKET_SEARCH: "Search by Ticket ID, Raised By",
  PAYOUT_SEARCH: "Search by Tutor ID, Name, Mobile, Email",
  PAYMENT_SEARCH: "Search by Transaction ID, Name, Mobile, ",

  TF: {
    CONTACT_NUMBER: "+91 9174465143",
  },
  IM: {
    CONTACT_NUMBER: "+91 7389563564",
  },

  LOACTION_PERMISSION_MSG: "Location permission is required to open the map.",
  LOACTION_PERMISSION_BTN_TEXT: "Click here to grant location access",
};
